const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

export const isSafeInternalPath = (url) => {
  if (!url || typeof url !== "string") return false;
  if (!url.startsWith("/")) return false;
  if (url.startsWith("//") || url.startsWith("/\\")) return false;
  if (url.includes("://")) return false;
  return true;
};

export const savePostLoginRedirect = (pathname, search = "") => {
  const url = `${pathname || ""}${search || ""}`;
  if (!isSafeInternalPath(url) || url === "/" || url === "/login") return;
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, url);
};

export const consumePostLoginRedirect = () => {
  const url = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return isSafeInternalPath(url) ? url : "";
};
